export const INSPECT_ATTR = {
    SECTION_ID: 'data-editor-section-id',
    SECTION_TYPE: 'data-editor-section-type',
    SECTION_INDEX: 'data-editor-section-index',
    /** Marks the container inside an HTML section's shadow root that scopes the CSS selector. */
    HTML_ROOT: 'data-editor-html-root',
    /** Zero-based `items[i]` index, stamped on each rendered carousel `<img>`. */
    CAROUSEL_ITEM_INDEX: 'data-editor-carousel-item-index',
    /**
     * Marks storefront chrome that sits outside the landing-page section list.
     * Live-edit lets clicks through these without Option/Alt: open cart / PDP /
     * PLP, fullscreen video, image lightboxes, and portaled dialogs. In-page
     * chrome (header, cart icon, hero video) is not stamped and still needs
     * the modifier.
     */
    OVERLAY: 'data-editor-overlay',
};
export const INSPECT_OVERLAY_ATTRS = {
    [INSPECT_ATTR.OVERLAY]: '',
};
/**
 * Data attributes RenderSections stamps onto every section wrapper so the
 * parent-side inspector can resolve any DOM click back to the owning section.
 *
 * `data-editor-section-index` is the discriminator the resolver actually keys
 * off — every section has an index. `data-editor-section-id` is only present
 * when the section carries a stable `AdminContentSection.id`; landing pages
 * saved before section ids were persisted come through without one. When the
 * id is missing, the agent turn falls back to the index to resolve the
 * current section id from the live page map (see `resolveContextSelections`).
 */
export function getInspectSectionAttrs(section, index) {
    const attrs = {
        [INSPECT_ATTR.SECTION_TYPE]: section.type,
        [INSPECT_ATTR.SECTION_INDEX]: String(index),
    };
    if (section.id)
        attrs[INSPECT_ATTR.SECTION_ID] = section.id;
    return attrs;
}
